import { DeleteTwoTone, EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link } from 'react-router-dom';
import ResponsiveDialog from '../dialog/dialog';
import { useNavigate } from 'react-router-dom';
import configurationService from '../../service/configurationService';

const TableConfiguration = ({data, onPageChange, onFilterChange, onSortChange}) => {

  const usuario = JSON.parse(localStorage.getItem('user_token')) || {};
  const permission = usuario.roles?.filter(item=>item.name === "Configuração")[0];

  let navigate = useNavigate();

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const [activeFilters, setActiveFilters] = useState({});

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();


  function refreshPage() {
    window.location.reload(false);
  }

  /**
   * @function mapColumnToBackend
   * @description Mapear nomes das colunas do frontend para o backend
   * @param {string} columnName - Nome da coluna do frontend
   * @returns 
   */
  const mapColumnToBackend = (columnName) => {
    const mapping = {
      'idconfiguration': 'idconfiguration',
      'environment': 'environment',
    };
    
    const normalizedColumn = columnName.toLowerCase();
    return mapping[normalizedColumn] || columnName;
  };

  /**
   * @function handleTableChange
   * @description Manipula mudanças na tabela (paginação, ordenação, filtros)
   */
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("🔄 [TableConfiguration] Mudança na tabela:", { pagination, filters, sorter });
    
    // Se houver ordenação e onSortChange foi passado
    if (sorter && sorter.columnKey && onSortChange) {
      const sortBy = mapColumnToBackend(sorter.columnKey);
      const sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : null;
      
      console.log("📊 [TableConfiguration] Ordenação:", { 
        coluna: sorter.columnKey, 
        sortBy, 
        sortOrder 
      });
      
      if (sortOrder) {
        onSortChange(sortBy, sortOrder);
      }
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex, close) => {
    console.log("🔍 [TableConfiguration] Aplicando filtro:", dataIndex, "=", selectedKeys[0]);
    
    if (selectedKeys[0] && selectedKeys[0].trim() !== "") {
      // Criar novo objeto de filtros ANTES de atualizar o estado
      const newFilters = {
        ...activeFilters,
        [dataIndex]: selectedKeys[0]
      };
      
      const backendFilters = {};
      Object.entries(newFilters).forEach(([key, value]) => {
        const backendKey = mapColumnToBackend(key);
        backendFilters[backendKey] = value;
      });
      
      console.log("📡 [TableConfiguration] Filtros frontend:", newFilters);
      console.log("📡 [TableConfiguration] Filtros backend:", backendFilters);
      
      // Notificar componente pai IMEDIATAMENTE (antes de atualizar estados)
      if (onFilterChange) {
        onFilterChange(backendFilters);
      }
      
      // DEPOIS atualizar estados locais (apenas para UI)
      setActiveFilters(newFilters);
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    }
    
    // Fechar dropdown sem confirmar filtro (porque não tem onFilter)
    if (close) {
      close();
    }
  };

  const handleReset = (clearFilters, dataIndex) => {
    console.log("🧹 [TableConfiguration] Limpando filtro:", dataIndex);
    
    if (clearFilters) {
      clearFilters();
    }
    
    if (searchedColumn === dataIndex) {
      setSearchText("");
      setSearchedColumn("");
    }

    const newFilters = { ...activeFilters };
    delete newFilters[dataIndex];
    setActiveFilters(newFilters);

    const backendFilters = {};
    Object.entries(newFilters).forEach(([key, value]) => {
      const backendKey = mapColumnToBackend(key);
      backendFilters[backendKey] = value;
    });

    // Notificar componente pai sobre mudança nos filtros
    if (onFilterChange) {
      console.log("📡 [TableConfiguration] Filtros frontend após reset:", newFilters);
      console.log("📡 [TableConfiguration] Filtros backend após reset:", backendFilters);
      onFilterChange(backendFilters);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Pesquisar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex, close)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex, close)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, dataIndex)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: activeFilters[dataIndex] ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });



  const deleteConfiguration = (id) => {

    configurationService.delete(id).then(item=> {
      setOpenDialog(true);
      setStatusDialog('success')
      setTitleDialog("Muito bem!")
      setMessageDialog("Configuração deletada com sucesso")

    }).catch(error=>{
        console.log(error)
        setOpenDialog(true);
        setStatusDialog('error')
        setTitleDialog("Ops!")
        setMessageDialog("Erro ao excluir a configuração " + id)
    })

  }

  const columns = [
    {
        title: 'Código',
        dataIndex: 'idconfiguration',
        width: '20%',
        key: 'idconfiguration',
        sorter: true,
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Ambiente',
        dataIndex: 'environment',
        key: 'environment',
        width: '50%',
        ...getColumnSearchProps('environment'),
        sorter: true,
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Ações',
        key: 'action',
        width: '30%',
        sorter: false,
        render: (_, record) => (
            <Space size="middle">
                <Link to={'/configuration/' + record.idconfiguration}>
                    { permission?.isinsert ? <EditOutlined style={{
                                  fontSize: '20px',
                                  color: '#4169E1'
                                }} />
                                 :
                                 <EyeOutlined style={{
                                  fontSize: '20px',
                                  color: '#4169E1'
                                }}  />}
                </Link>
                {
                    permission?.isremove ?
                        <Link to={'#'}>
                             <DeleteTwoTone 
                                twoToneColor="#DC143C"
                                style={{
                                  fontSize: '20px',
                                }}  
                                onClick={(e) => deleteConfiguration(record.idconfiguration)} 
                                />
                        </Link>
                    : 
                    ""
                }
            </Space>
        ),
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    navigate("/listConfiguration");
    refreshPage();
}

  return (

    <>

      <ResponsiveDialog 
            open={openDialog} 
            handleClose={handleDialogClose}
            title={titleDialog}
            message={messageDialog} 
            status={statusDialog}
      />

      <Table
        columns={columns} 
        dataSource={Array.isArray(data?.data) ? data.data : []}
        rowKey="idconfiguration"
        locale={{
          emptyText: "Nenhuma configuração encontrada"
        }}
        onChange={handleTableChange}
        pagination={{
          current: data?.pagination?.currentPage || 1,
          pageSize: data?.pagination?.itemsPerPage || 10,
          total: data?.pagination?.totalItems || 0,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: (page, pageSize) => {
            console.log("🔄 [TableConfiguration] Mudando para página:", page, "Tamanho:", pageSize);
            if (onPageChange) {
              onPageChange(page, pageSize);
            }
          },
          onShowSizeChange: (current, size) => {
            console.log("🔄 [TableConfiguration] Mudando tamanho da página:", size);
            if (onPageChange) {
              onPageChange(1, size);
            }
          }
        }}
      />
    </>
     
  )
  

};

export default TableConfiguration;
